module.exports = __webpack_public_path__ + "img/slide-9-1.ed82f0d1.jpg";